export enum UserRole {
  ADMIN = 'Admin',
  DONOR = 'Donor',
  RECIPIENT = 'Recipient',
}
